/**
 * Created by pandemio on 4/11/19.
 */
import React from 'react';
import {Card, Col, Container, Row, Button} from 'reactstrap';
import {Link} from "react-router-dom";

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
import NavbarDesktop from './navbar-employee/navbar-desktop';
import NavbarMobile from './navbar-employee/navbar-mobile';
import Footer from '../footer/footer';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint, faUsers, faIdBadge, faChartLine } from '@fortawesome/free-solid-svg-icons';
import ApiCalls from '../../custom-classes/api-calls';
import Switch from 'react-switch';
import DateFormater from '../../custom-classes/date-formater';
import ChartBar from '../charts/chart-bar';

/**
 * The dashboard of the employee
 */
class ReportArea extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        let languages = [
            {name: "English", code: "en"},
            {name: "Español", code: "es"}
        ];

        // To support language library add the following lines
        this.props.initialize({
            languages,
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });

        this.state = {

        };
        this.props.addTranslation(global);
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();

    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    /**
     * Renders the main dashboard
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className={this.state.navbarMobile ? "margin-top-mandatory-60" : null}>
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faPrint}/>{' '}
                            <Translate id="reports.reports" options={{renderInnerHtml: true}}/>
                        </h2>
                        <small className="white-text">
                            <Translate id="reports.report-instructions" options={{renderInnerHtml: true}}/>
                        </small>
                        <hr/>
                        <Row>
                            <Col lg={{size: 10, offset: 1}} md={{size: 10, offset: 1}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-darker-transparency">
                                    <Row>
                                        <Col  className="centered-text" lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faIdBadge} size="4x"/>{'   '}
                                        </Col>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                                     <span className="font-now-bold">
                                                         <Translate id="reports.subscriptions"/>
                                                     </span>
                                            <br/>
                                            <small><Translate id="reports.subscriptions-instructions"/></small>
                                            <hr/>
                                            <Link to="/report-subscriptions" className="btn btn-outline-light">
                                                <Translate id="reports.go" options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col lg={{size: 10, offset: 1}} md={{size: 10, offset: 1}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-darker-transparency">
                                    <Row>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                                     <span className="font-now-bold">
                                                         <Translate id="reports.clients"/>
                                                     </span>
                                            <br/>
                                            <small><Translate id="reports.clients-instructions"/></small>
                                            <hr/>
                                            <Link to="/report-clients" className="btn btn-outline-light">
                                                <Translate id="reports.go" options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                        <Col  className="centered-text" lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faUsers} size="2x"/>{'   '}
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col lg={{size: 10, offset: 1}} md={{size: 10, offset: 1}} sm={{size: 12}} xs={{size: 12}}>
                                <Card body className="card-darker-transparency">
                                    <Row>
                                        <Col className="centered-text" lg={{size: 2}} md={{size: 2}} sm={{size: 2}} xs={{size: 2}}>
                                            <FontAwesomeIcon icon={faChartLine} size="4x"/>{'   '}
                                        </Col>
                                        <Col lg={{size: 10}} md={{size: 10}} sm={{size: 10}} xs={{size: 10}}>
                                                     <span className="font-now-bold">
                                                         <Translate id="reports.use"/>
                                                     </span>
                                            <br/>
                                            <small><Translate id="reports.use-instructions"/></small>
                                            <hr/>
                                            <Link to="/report-usage" className="btn btn-outline-light">
                                                <Translate id="reports.go" options={{renderInnerHtml: true}}/>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>

        )
    };
}

export default withLocalize(ReportArea);